// ** Reducers Imports
/* eslint-disable */
import layout from "./layout"
import navbar from "./navbar"
import authSlice from "./authSlice"
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  user: authSlice,
  navbar: navbar,
  layout: layout,
});


//const rootReducer = { navbar, layout, authSlice };

export default rootReducer
